export default {
  listProtocolType: [],
  protocolType: {
    descricao: '',
    entrada: false,
    saida: false,
    ativo: true,
  },
}
